//#region src/properties/rejoinMapImages.ts
var e = (e, t) => ({
	...e,
	images: e.images.map((e) => e.startsWith("http") ? e : `${t ?? ""}${e}`)
});
//#endregion
export { e as rejoinMapImages };
